export default __webpack_public_path__ + "./assets/the-mix-c5-semilight.woff2";